import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { FaqConfigSecondVariant } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant2',
  imports: [DatePipe, SafePipe, VariableReplacementPipe],
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
})
export class Variant2Component extends BaseComponent {
  config = input.required<FaqConfigSecondVariant>();

  public activeTab = this.dataService.activeTabs.faq;
  public expandedAccordions: Set<number> = new Set<number>();
}
